module.exports = __webpack_public_path__ + "static/logo_white-d2ba5b2e1b6b471881e638ec33ec1449.png";